import { useState } from 'react'
import logger from '../utils/logger'

/**
 * 섹션 데이터 관리를 위한 커스텀 훅
 */
function useSections() {
  const [sections, setSections] = useState([])

  const addSections = (newSections) => {
    setSections(newSections)
  }

  const updateSectionMedia = (sectionId, media, mediaType) => {
    setSections(prevSections =>
      prevSections.map(section =>
        section.id === sectionId
          ? { ...section, media, mediaType }
          : section
      )
    )
  }

  const updateSectionFiles = (sectionId, files) => {
    logger.debug(`📝 Updating section ${sectionId} with files:`, files)
    setSections(prevSections => {
      const updatedSections = prevSections.map(section =>
        section.id === sectionId
          ? { 
              ...section, 
              imageFile: files.image, 
              videoFile: files.video, 
              urlMedia: files.url,
              audioFile: files.audio,
              audioFileObject: files.audioFileObject, // 실제 오디오 파일 객체
              mp4File: files.mp4,
              hasAudioInVideo: files.hasAudioInVideo,
              // 백엔드가 기대하는 필드 추가
              imageUrl: files.imageUrl,  // Supabase 이미지 URL
              videoUrl: files.videoUrl   // Supabase 비디오 URL
            }
          : section
      )
      logger.debug(`✅ Sections after update:`, updatedSections.map(s => ({ id: s.id, audio: s.audioFile })))
      return updatedSections
    })
  }

  const updateSectionText = (sectionId, newText) => {
    setSections(prevSections =>
      prevSections.map(section =>
        section.id === sectionId
          ? { ...section, text: newText }
          : section
      )
    )
  }

  const removeSection = (sectionId) => {
    setSections(prevSections => {
      const filteredSections = prevSections.filter(section => section.id !== sectionId)
      // 번호 재정렬
      return filteredSections.map((section, idx) => ({
        ...section,
        index: idx + 1
      }))
    })
  }

  // 이미지/비디오만 제거하고 텍스트와 오디오는 유지
  const removeMediaOnly = (sectionId) => {
    setSections(prevSections =>
      prevSections.map(section =>
        section.id === sectionId
          ? {
              ...section,
              imageFile: null,
              videoFile: null,
              mp4File: null,
              urlMedia: null,
              hasAudioInVideo: false,
              media: null,
              mediaType: null
            }
          : section
      )
    )
  }

  const getSectionById = (sectionId) => {
    return sections.find(section => section.id === sectionId)
  }

  return {
    sections,
    setSections,  // 프로젝트 불러오기를 위해 추가
    addSections,
    updateSectionMedia,
    updateSectionFiles,
    updateSectionText,
    removeSection,
    removeMediaOnly,
    getSectionById
  }
}

export default useSections